"use strict";

define('rs/models/person',['rs/models/abstract', 'rs/models/role', 'jquery'], function (AbstractModel, Role, $) {
  var PersonModel = AbstractModel.extend({
    properties: ['activityDate', 'displayName', 'features', 'primaryAddress', 'primaryEmail', 'primaryPhone', 'organization', 'prefix', 'permissions', 'roles', 'trainingLink'],
    serverProperties: ['id', 'appointments', 'emails', 'phones', 'addresses', 'firstName', 'lastName', 'middleName', 'prefix', 'suffix', 'updateUserAuthId', 'version'],
    initialize: function initialize() {
      this.listenTo(this, 'change:addresses', this.loadPrimaryAddress);
      this.listenTo(this, 'change:emails', this.loadPrimaryEmailAddress);
      this.listenTo(this, 'change:phones', this.loadPreferredPhoneNumber);
      this.listenTo(this, 'change:appointments', this.loadPreferredOrganization);
      this._super.apply(this, arguments);
      this.setEmails(this.emails || []);
      this.setPhones(this.phones || []);
      this.setTrainingLink('View');
      if (!this.getDisplayName()) {
        this.setDisplayName(this.getFirstName() + ' ' + this.getLastName());
      }
    },
    loadPreferredOrganization: function loadPreferredOrganization() {
      var org = '',
        appointments = this.getAppointments() || [];
      org = _.find(appointments, function (appointment, index, list) {
        return appointment.primary == true || list.length == 1 || index == list.length - 1;
      });
      this.setOrganization(org ? org.orgTitle : '');
    },
    loadPrimaryAddress: function loadPrimaryAddress() {
      var addresses = this.getAddresses() || [],
        primary = null;
      primary = _.find(addresses, function (address, index, list) {
        return address.preferred == true || list.length == 1 || index == list.length - 1;
      });
      if (primary) {
        primary.fullAddress = this.parseAddress(primary);
      }
      this.setPrimaryAddress(primary);
    },
    parseAddress: function parseAddress(address) {
      var stateProvince = address.stateProvince || {};
      return [[address.street1, address.street2].join(' '), ', ', address.city, ', ', stateProvince.code || stateProvince.name, ' ', address.postalCode].join('');
    },
    loadPrimaryEmailAddress: function loadPrimaryEmailAddress() {
      var emails = this.getEmails() || [],
        primary = null;
      primary = _.find(emails, function (email, index, list) {
        return email.preferred == true || list.length == 1 || index == list.length - 1;
      });
      this.setPrimaryEmail(primary);
    },
    loadPreferredPhoneNumber: function loadPreferredPhoneNumber() {
      var phones = this.getPhones() || [],
        extension = null,
        primary = null;
      primary = _.find(phones, function (phone, index, list) {
        return phone.preferred == true || list.length == 1 || index == list.length - 1;
      });
      if (primary) {
        extension = primary.extension;
        primary.fullNumber = extension ? primary.number + ' ext. ' + extension : primary.number;
      }
      this.setPrimaryPhone(primary);
    },
    remove: function remove() {
      return this.constructor.deletePerson(this.getId());
    },
    requestDetails: function requestDetails() {
      var that = this;
      if (this.hasDetails) {
        return Promise.resolve();
      } else {
        return this.constructor.requestDetails(this.getId()).tap(function (data) {
          that.hasDetails = true;
          that.updateWith(data);
        });
      }
    },
    requestUpdateRoles: function requestUpdateRoles(addRoles, removeRoles) {
      return this.constructor.requestUpdateRolesByPerson(this.getId(), addRoles, removeRoles);
    },
    update: function update(data) {
      this.hasDetails = false;
      this.applyProperties(data);
      return this.constructor.updatePerson(this).bind(this).tap(function (model) {
        this.hasDetails = true;
        this.updateWith(model);
      });
    },
    hasRole: function hasRole(roleToCheck) {
      var roles = this.getRoles();
      return _.contains(roles, roleToCheck);
    },
    supportsFeature: function supportsFeature(feature) {
      var features = this.getFeatures() || {};
      if (feature) {
        return features[feature];
      }
      return true;
    },
    hasPermission: function hasPermission(permissionToCheck) {
      var permissions = this.getPermissions(),
        pCache = this.pCache || (this.pCache = {});
      if (pCache[permissionToCheck] !== undefined) {
        return pCache[permissionToCheck];
      }
      return pCache[permissionToCheck] = _.contains(permissions, permissionToCheck);
    },
    hasPermissions: function hasPermissions(permissionList) {
      permissionList = permissionList || [];
      for (var i = 0, len = permissionList.length; i < len; i++) {
        if (!this.hasPermission(permissionList[i])) {
          return false;
        }
      }
      return true;
    },
    loadAuthorities: function loadAuthorities(authorities) {
      var permissions = [],
        roles = [];
      for (var i = 0, len = authorities.length, a = null; i < len; i++) {
        a = authorities[i].authority;
        if (a.indexOf('PERM_') == 0) {
          permissions.push(a.substring(5));
        } else if (a.indexOf('ROLE_') == 0) {
          roles.push(a.substring(5));
        }
      }
      this.setRoles(roles);
      this.setPermissions(permissions);
    }
  }, {
    rootURI: '/rs/api/',
    model: function model(data) {
      if (data.personId) {
        data.id = data.personId;
      }
      if (data.person) {
        return new PersonModel(data.person);
      } else {
        return new PersonModel(data);
      }
    },
    parsers: {
      '#get#person(?*query)': function getPersonQuery(data) {
        return this.models(data);
      },
      '#get#person/finder(?*query)': function getPerson_finderQuery(data) {
        return this.models(data);
      },
      '#post#person': function postPerson(data) {
        return this.model(data);
      },
      'person/:id': function person_Id(data) {
        return this.model(data);
      },
      '#get#role/:id/person': function getRole_Id_person(data) {
        return this.models(data);
      },
      '#post#role/:id/person': function postRole_Id_person(data) {
        return data;
      }
    },
    createPerson: function createPerson(data) {
      return this.post('person', data, {
        jsonBody: true
      });
    },
    deletePerson: function deletePerson(id) {
      return this.del('person/' + id);
    },
    requestDetails: function requestDetails(id) {
      return this.get('person/' + id);
    },
    requestDetailsByAuthId: function requestDetailsByAuthId(id) {
      return this.get('user/' + id);
    },
    requestDetailsByAuthIds: function requestDetailsByAuthIds(ids) {
      var d = Promise.join(),
        that = this,
        len = ids ? ids.length : 0,
        auths = [],
        i = 0;
      for (i = 0; i < len; ++i) {
        (function (index, id) {
          d = Promise.join(d, that.requestDetailsByAuthId(id)).spread(function (stupid, info) {
            auths[index] = info ? info[0] : null;
          });
        })(i, ids[i]);
      }
      return d.then(function () {
        return auths;
      });
    },
    requestPersonnel: function requestPersonnel() {
      return this.get('person');
    },
    getQuery: function getQuery(qstr, limit, page) {
      var paramObj = {
        a: true
      };
      if (qstr) {
        paramObj.q = qstr;
      }
      if (limit) {
        paramObj.n = limit;
      }
      if (page) {
        paramObj.s = page;
      }
      return this.get('person/finder?' + $.param(paramObj));
    },
    updatePerson: function updatePerson(model) {
      return this.put('person/' + model.getId(), model);
    },
    requestUpdateRolesByPerson: function requestUpdateRolesByPerson(id, addRoles, removeRoles) {
      return this.post('role/person/' + (Number(id) || 0), {
        insert: addRoles || undefined,
        remove: removeRoles || undefined
      }, {
        jsonBody: true
      });
    },
    requestPersonsByRole: function requestPersonsByRole(roleId) {
      return this.get('role/' + (Number(roleId) || 0) + '/person');
    },
    requestPersonsByRoleName: function requestPersonsByRoleName(roleName) {
      return Role.requestRoles().bind(this).then(function (roles) {
        var personnelRole = _.findWhere(roles, {
          name: roleName
        });
        if (!personnelRole) {
          throw new Error(roleName + ' role was not found');
        }
        return this.requestPersonsByRole(personnelRole.getId());
      });
    }
  });
  return PersonModel;
});

